<template>
    <span></span>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'loader',
        computed: {
            ...mapGetters({
                tasks: 'LoaderScreen/tasks'
            })
        },
        data () {
            return {
                isLoaderShown: false,
                loader: null,
                overlayTimeoutId: null,
                secondOverlayTimeoutId: null
            }
        },
        methods: {
            toggleTasks (currentTasks) {
                if (currentTasks.length > 0 && !this.isLoaderShown) {
                    this.showLoader()
                }

                if (currentTasks.length === 0 && this.isLoaderShown) {
                    this.hideLoader()
                }
            },
            showLoader () {
                this.isLoaderShown = true
                this.overlayTimeoutId = setTimeout(() => {
                    this.loader = this.$loading.show({ loader: 'dots' })
                }, 300)

                this.secondOverlayTimeoutId = setTimeout(() => {
                    clearTimeout(this.overlayTimeoutId)
                    this.loader?.hide()
                    this.loader = this.$loading.show({ loader: 'spinner', opacity: 0.8, canCancel: true, onCancel: this.clearBlockers }, { before: <TotemLoaderMsg /> })
                }, 5000)
            },
            clearBlockers () {
                this.$store.dispatch('LoaderScreen/clearBlockers')
            },
            hideLoader () {
                clearTimeout(this.overlayTimeoutId)
                clearTimeout(this.secondOverlayTimeoutId)
                this.loader?.hide()
                this.isLoaderShown = false
            },
        },
        watch: {
            tasks: {
                handler: 'toggleTasks',
                immediate: true
            }
        }
    }
</script>

<style scoped>

</style>
